<button
  mat-icon-button
  color=""
  [matTooltip]="T_SCOPE | translate"
  (click)="createNotification()"
  onclick="this.blur()"
>
  <mat-icon>notification_add</mat-icon>
</button>
